import { ActionItem } from 'modules/processes/domain/action'

export enum DataCollectionCategories {
  bankInformation = 'bank_information',
  identificationNumber = 'identification_number',
  generalInformation = 'general_information',
  familySituation = 'family_situation',
  address = 'address',
  fiscal_residence = 'fiscal_residence',
  emergency_contact = 'emergency_contact',
  employee_questions_cf = 'employee_questions_cf',
  start_date = 'start_date',
  role = 'role',
  salary = 'salary',
  contract_hours = 'contract_hours',
  contract_data = 'contract_data',
  contract_custom_fields = 'contract_custom_fields',
  personalSituation = 'personal_situation',
}

export interface Item {
  id: string
  configurationId?: string | null
  configurationType?: string | null
  position: number
  stepId?: string | null
  itemAssignee?: {
    id: string
    assigneeIds: string[]
    assigneeStrategy: string
    peopleGroupId?: string | null
  } | null
  documentTemplateId?: string | null
  instruction?: string | null
  mandatory?: boolean | null
  offsetAmount?: number | null
  offsetDirection?: string | null
  referenceFieldKey?: string | null
  taskType?: string | null
  taskTypeConfiguration?: string | null
  title?: string | null
  configurationIdentifier?: string | null
  configuration?: string | null
  includeAssignees?: boolean | null
  includeFiles?: boolean | null
  files?: ActionItem['files']
}
